import React, {useContext, useEffect, useCallback} from 'react'
import {Grid, FormControl, InputLabel, MenuItem, Select, FormHelperText} from '@material-ui/core'
import {ReservationConfigurationContext} from './../../../../context/ReservationConfiguration'
import {getEntityObjects} from '../../../../state/entities/get-entity-objects-v2/actions'
import useGetEntityObjectsReducer, {
  ActionTypes as getReservationEntityItemsActionTypes,
} from '../../../../state/entities/get-entity-objects-v2/reducer'
import _ from 'lodash'

export default function WMemoField({data, onChange}) {
  const [entityObjects, entityObjectsDispatch] = useGetEntityObjectsReducer()

  const loadEntityObjects = useCallback(
    (group_id, params = {}) => {
      getEntityObjects(entityObjectsDispatch, group_id, params)
    },
    [entityObjectsDispatch]
  )
  useEffect(() => {
    let fIds = []
    if (data?.list_limit_attributes?.length === 0 || data?.list_limit_attributes === null) {
      fIds =
        !_.isEmpty(data?.list_filters_attributes) &&
        data?.list_filters_attributes.map(val => val.type_id)
      loadEntityObjects(data?.description, {list_for_field: fIds})
    } else if (data?.list_limit_attributes?.length > 0) {
      loadEntityObjects(data?.description, {ids: data.list_limit_attributes, list_for_field: fIds})
    }
  }, [data, loadEntityObjects])
  return (
    <Grid item xs={6}>
      <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
        <InputLabel id="demo-mutiple-name-label">{data.name}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label={data.name}
          value={data.value}
          onChange={(e, i) => {
            onChange(e, 'value', data, i)
          }}
        >
          {entityObjects?.data?.objects?.map(o => {
            return <MenuItem value={o.id}>{o.display_name}</MenuItem>
          })}
        </Select>
        <FormHelperText>{!data.is_required ? 'optional' : ''}</FormHelperText>
      </FormControl>
    </Grid>
  )
}
